__turbopack_context__.v({
  "overviewContainer": "EarningsOverview-module-scss-module__5_P7aq__overviewContainer",
});
